import React, {PureComponent} from 'react';
import {Row, Col} from 'reactstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

//utils
import {getStoreData} from "../../../utils/getStoreData";
import {returnBootstrapColor} from "../../../utils/returnBootstrapColor";

//constants
import {ADD, DEL, GET} from "../../../config/requestConstants";

//components
import TherapyForm from './TherapyForm';

//redux
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchVisit2TherapyData} from "../../../redux/actions/visit2/visit2TherapyAction";

class TherapyCard extends PureComponent {
    static defaultProps = {
        readOnly: false
    };

    componentDidMount() {
        this.getInitialData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.getInitialData();
        }
    }

    getInitialData = () => {
        const {
            fetchVisit2TherapyData,
            id
        } = this.props;

        if (!id) return;

        const filter = [{name:"sub", value: this.props.id}];

        fetchVisit2TherapyData(GET, filter);
    };

    addNewCard = async () => {
        const {
            fetchVisit2TherapyData,
            id
        } = this.props;

        const data = {
            sub: id
        };

        await fetchVisit2TherapyData(ADD, [], data, false);
        this.getInitialData();
    };

    onDelete = async (values) => {
        const {
            fetchVisit2TherapyData,
        } = this.props;

        const data = {
            id: values.id
        };

        await fetchVisit2TherapyData(DEL, [], data, false);
        this.getInitialData();
    };

    render() {
        const {
            therapy,
            _onChange,
            _onCheckboxChange,
            readOnly
        } = this.props;

        return (
            <Row>
                {
                    therapy && therapy.map(item =>
                        <TherapyForm
                            key={item.id}
                            form={`visit2_therapy_form_${item.id}`}
                            data={item}
                            _onChange={_onChange}
                            _onCheckboxChange={_onCheckboxChange}
                            onDelete={this.onDelete}
                            readOnly={readOnly}
                        />
                    )
                }
                {!readOnly && <Col xs={12} md={6} className={"mb-4"}>
                    <div className="visitCard visitCard_pointer d-flex justify-content-center align-items-center">
                        <Row>
                            <Col xs={12} className="visitCard__add d-flex justify-content-center align-items-center"
                                 onClick={this.addNewCard}>
                                <FontAwesomeIcon icon={"plus"} color={returnBootstrapColor('success')}/>
                            </Col>
                        </Row>
                    </div>
                </Col>}
            </Row>
        )
    }
}

const mapStateToProps = (store) => ({
    therapy: getStoreData(() => store.visit2Therapy.initialData.data)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchVisit2TherapyData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TherapyCard);
